export default {
  LOCALE_FORMATS: state => state.localeFormats,
  SHARING_LIST_TYPES: state => state.sharingListTypes,
  SHOW_ARCHIVED_SECTIONS: state => state.showArchivedSections,
  OS2FAKTOR_WAIT_FOR_AUTHENTICATION_TIMEOUT: state => state.os2faktorWaitForAuthenticationTimeout,
  OS2FAKTOR_SESSION_TIMEOUT: state => state.os2faktorSessionTimeout
};
